const authFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2.5,
    backgroundColor: '#f5f7fa',
    transition: 'box-shadow 160ms ease, background-color 160ms ease',
    '& fieldset': { borderColor: '#d8dee6' },
    '&:hover fieldset': { borderColor: '#aeb8c4' },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      boxShadow: '0 0 0 3px rgba(80, 170, 71, 0.14)',
      '& fieldset': { borderColor: '#50aa47' },
    },
  },
  '& .MuiInputLabel-root': {
    color: '#6f7775',
    fontWeight: 400,
  },
  '& .MuiInputLabel-root.Mui-focused': { color: '#309e43' },
}

export default authFieldSx
